import { useEffect, useRef, useState } from "react";

/**
 * Reveals paragraphs one by one, each with a typewriter effect.
 * Returns the current visible content as an array of strings (per paragraph).
 */
export default function useTypewriter(paragraphs, speed = 18) {
  const [visible, setVisible] = useState([]);
  const [isDone, setIsDone] = useState(false);
  const cancelled = useRef(false);

  useEffect(() => {
    cancelled.current = false;
    setVisible([]);
    setIsDone(false);

    if (!paragraphs || paragraphs.length === 0) return;

    let pIdx = 0;
    let cIdx = 0;
    const buffer = paragraphs.map(() => "");

    const tick = () => {
      if (cancelled.current) return;
      if (pIdx >= paragraphs.length) {
        setIsDone(true);
        return;
      }
      const current = paragraphs[pIdx];
      cIdx += 2; // step
      buffer[pIdx] = current.slice(0, cIdx);
      setVisible([...buffer]);

      if (cIdx >= current.length) {
        pIdx += 1;
        cIdx = 0;
        setTimeout(tick, 280); // pause between paragraphs
      } else {
        setTimeout(tick, speed);
      }
    };

    tick();
    return () => {
      cancelled.current = true;
    };
  }, [paragraphs, speed]);

  const skip = () => {
    cancelled.current = true;
    setVisible(paragraphs || []);
    setIsDone(true);
  };

  return { visible, isDone, skip };
}
